import React, { useState, useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory, Link } from 'react-router-dom'
import { facultyLogin } from '../redux/action/facultyAction'
import { studentLogin } from '../redux/action/studentAction'
import classnames from 'classnames'

import '../Style/facultyStudentLogin.css'


const FacultyStudentLoginPags = () => {
    const store = useSelector((state) => state)
    const dispatch = useDispatch()
    const [facultyRegNum, setFacultyRegNum] = useState('')
    const [facultyPassword, setFacultyPassword] = useState('')
    const [studentRegNum, setStudentRegNum] = useState('')
    const [studentPassword, setStudentPassword] = useState('')
    const [errors, setErrors] = useState({})
    const [errorsHelper, setErrorsHelper] = useState({})
    const [isFacultyLoading, setIsFacultyLoading] = useState(false)
    const [isStudentLoading, setIsStudentLoading] = useState(false)


    const history = useHistory()

    useEffect(() => {
        if (store.faculty.isAuthenticated) {
            history.push('/faculty')
        }
    }, [store.faculty.isAuthenticated])

    useEffect(() => {
        if (store.error) {
            setErrors(store.error)
        }
    }, [store.error])
    useEffect(() => {
        if (store.student.isAuthenticated) {
            history.push('/home')
        }
    }, [store.student.isAuthenticated])

    useEffect(() => {
        if (store.errorHelper) {
            setErrorsHelper(store.errorHelper)
        }
    }, [store.errorHelper])






    const facultyFormHandler = (e) => {
        e.preventDefault()
        let registrationNumber;
        let password;
        setIsFacultyLoading(true)
        dispatch(facultyLogin({ registrationNumber: facultyRegNum, password: facultyPassword }))
    }

    useEffect(() => {
        if (store.error || store.faculty.isAuthenticated) {
            setIsFacultyLoading(false)
        }
        else {
            setIsFacultyLoading(true)
        }
    }, [store.error, store.faculty.isAuthenticated])

    const studentFormHandler = (e) => {
        e.preventDefault()
        let registrationNumber;
        let password;
        setIsStudentLoading(true)
        dispatch(studentLogin({ registrationNumber: studentRegNum, password: studentPassword }))
    }

    useEffect(() => {
        if (store.errorHelper ||
            store.student.isAuthenticated) {
            setIsStudentLoading(false)
        }
        else {
            setIsStudentLoading(false)
        }

    }, [store.errorHelper, store.student.isAuthenticated])

    document.addEventListener('DOMContentLoaded', function () {
        let time = new Date();
        var dayNames = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
        var day = dayNames[time.getDay()];
        var Date1 = time.getDate();
        var month = time.getMonth() +1;
        var hours = time.getHours();
        var minutes = time.getMinutes();
        var seconds = time.getSeconds();
        var year = time.getFullYear();

        month = month < 10 ? '0' + month : month;
        Date1 = Date1 < 10 ? '0' + Date1 : Date1;
        hours = hours < 10 ? '0' + hours : hours;
        minutes = minutes < 10 ? '0' + minutes : minutes;
        seconds = seconds < 10 ? '0' + seconds : seconds;

        var formattedDate = day+' '+Date1 + '-'+ month +'-'+year+' '+hours+':'+minutes+':'+seconds;
        
        document.querySelector('span').textContent = formattedDate;
    });


    return (
        <div className='mainRoot'>
            <div id="trail">
                <div className="container d-flex justify-content-center ">
                    <img src='/image/arjlogo.png' className='img-fluid ' alt="" />
                </div>
            </div>
            <div className="container-fluid col-11 border mainLogin">
                <p className='text-center m-3 text-secondary'><h4>Welcome to ARJCET-ERP PORTAL !!!</h4>" Here, you can access essential information such as cycle test marks, attendance records, student details, and fees structures, all at your fingertips." ARJCET students can login with RegNO credentials.(If you are a new student, please provide your Registration Number (RegNO) and Password to the admin to gain access to the portal.)</p>
                <div className='d-flex'>
                    <div className="row my-5">
                        <div className="col-md-3 m-md-auto ">
                            <div className='fLogin border'>
                                <h5 className="text-center ">FACULTY</h5>
                                <form noValidate onSubmit={facultyFormHandler} className='p-3'>
                                    <div className="form-group">
                                        <label htmlFor="facRegId">Faculty Id:</label>
                                       <div className='d-flex align-items-center fid'>
                                       <div className="icon1">
                                       <img src='/image/FidICON.png' alt="" />
                                       </div>
                                            <input placeholder='Enter Faculty ID..' onChange={(e) => setFacultyRegNum(e.target.value)} type="text" value={facultyRegNum} className={classnames('form-control', {
                                                'is-invalid': errors.registrationNumber
                                            })}
                                                id="facRegId" />
                                       </div>
                                        {errors.registrationNumber && (
                                            <div className="invalid-feedback">{errors.registrationNumber}</div>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="passwordFacId">Faculty Password :</label>
                                    <div className='d-flex align-items-center fid'>
                                    <div className="icon1">
                                       <img src='/image/Lock.png' alt="" />
                                       </div>
                                        <input placeholder='Enter Password...' onChange={(e) => setFacultyPassword(e.target.value)} value={facultyPassword} className={classnames("form-control", {
                                            'is-invalid': errors.password
                                        })}
                                            type="password" id="passwordFacId" />
                                    </div>
                                        {errors.password && (
                                            <div className="invalid-feedback">{errors.password}</div>
                                        )}
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className=" col">
                                            {
                                                isFacultyLoading && <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            }
                                        </div>
                                    </div>

                                    {!isFacultyLoading && <button type="submit" className="btn Lbtn">Login</button>}
                                </form>
                            </div>
                        </div>
                        <div className="col-md-3 my-5 m-md-auto ">
                            <div className='fLogin border'>
                                <h5 className="text-center">STUDENT</h5>
                                <form noValidate onSubmit={studentFormHandler} className='p-3'>
                                    <div className="form-group">
                                        <label htmlFor="studentId">Student RegNo:</label>
                                        <div className='d-flex align-items-center fid'>
                                        <div className="icon1">
                                         <img src='/image/stuidICON.png' alt="" />
                                        </div>  
                                        <input placeholder='Enter RegNo..' onChange={(e) => setStudentRegNum(e.target.value)} type="text" value={studentRegNum} className={classnames('form-control', {
                                            'is-invalid': errorsHelper.registrationNumber
                                        })}
                                            id="studentId" />
                                        </div>
                                        {errorsHelper.registrationNumber && (
                                            <div className="invalid-feedback">{errorsHelper.registrationNumber}</div>
                                        )}
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="passwordId">Student Password:</label>
                                        <div className='d-flex align-items-center fid'>
                                    <div className="icon1">
                                       <img src='/image/Lock.png' alt="" />
                                       </div>
                                        <input placeholder='Enter Password...' onChange={(e) => setStudentPassword(e.target.value)} value={studentPassword} className={classnames("form-control", {
                                            'is-invalid': errorsHelper.password
                                        })}
                                            type="password" id="passwordId" />
                                        </div>
                                        {errorsHelper.password && (
                                            <div className="invalid-feedback">{errorsHelper.password}</div>
                                        )}
                                    </div>
                                    <div className="row justify-content-center">
                                        <div className="col">
                                            {
                                                isStudentLoading && <div className="spinner-border text-primary" role="status">
                                                    <span className="sr-only">Loading...</span>
                                                </div>
                                            }
                                        </div>
                                    </div>
                                    {!isStudentLoading && <button type="submit" className="btn Lbtn ">Login</button>}

                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <footer className='w-100 p-1 d-md-flex justify-content-between text-light'>
                <span id='TimeGet'></span><br />
                <a href="https://www.codehomies.in/">ARJCET® ERP Developed by Code Homies</a>
            </footer>
        </div>
    )
}

export default FacultyStudentLoginPags
